module.exports = __webpack_public_path__ + "img/ComplianceDonutStatus.2f5c542a.png";